import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import classNames from 'classnames';
import ScenarioTable from '../../../components/ScenarioTable.react';
import { ScenarioPropTypes } from '../../../util/helpers/SharedPropTypes';

function _checkMatch(scenario, filter) {
  const re = new RegExp(filter, 'i');
  return scenario.name.match(re);
}

export default class FilteringScenarioTable extends React.Component {
  constructor(props) {
    super(props);
    this.filteredScenarios = this.filteredScenarios.bind(this);
    this.hasScenarios = this.hasScenarios.bind(this);
  }

  filteredScenarios() {
    return this.props.scenarios.filter(scenario =>
      _checkMatch(scenario, this.props.filter));
  }

  hasScenarios() {
    return this.filteredScenarios().size > 0;
  }

  render() {
    const divClass = classNames({ 'scenario-container jobTable': this.hasScenarios() });

    return (
      <div className={divClass}>
        <h3>{this.hasScenarios() ? this.props.title : ''}</h3>
        {
          this.filteredScenarios().size > 0 && (
            <ScenarioTable
              scenarios={this.filteredScenarios()}
              title={this.props.title}
            />
          )
        }
      </div>
    );
  }
}

FilteringScenarioTable.propTypes = {
  filter: PropTypes.string,
  title: PropTypes.string,
  scenarios: ImmutablePropTypes.iterableOf(ScenarioPropTypes),
};
